module.exports = __webpack_public_path__ + "static/media/polar-bear.f9f21649.png";